// PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) return null; // أو عرض مؤشر تحميل <LoadingSpinner />

  if (!token) return <Navigate to="/login" />;
  return children;
};

export default PrivateRoute;
